import React from "react";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import "./App.css";

function Services() {

  const navigate = useNavigate();

  const goToHome = () => {
    navigate("/home");
  };

  return (
    <div className="services-container">

      <Helmet>
        <title>PRO AI Writing Services | AI Paragraph Generator Tools</title>

        <meta
          name="description"
          content="Explore our AI writing services including AI paragraph generator, essay writing assistant, blog content generator, and article introduction generator. Create high-quality content instantly."
        />

        <meta
          name="keywords"
          content="Pro AI Paragraph Generator, AI writing services, AI paragraph generator, ai Writing Assistant, Blog Content Generator, Topic Idea Generator, Article Introduction Generator, essay writing AI, blog content generator, content writing instantly, Email Writing Assistant, SEO Content Generator, Story Generator, Product Description Generator, AI article generator, paragraph generator tool, blog post content generator, Professional AI writer, AI content generator, AI writing assistant, AI writing tools"
        />

        <link rel="canonical" href="https://proaiparagraph.vercel.app/Services" />

        <meta property="og:title" content="AI Writing Services - AI Paragraph Generator Tools" />
        <meta
          property="og:description"
          content="Use powerful AI writing tools to generate paragraphs, essays, blog content, and article introductions instantly."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://proaiparagraph.vercel.app/Services" />
      </Helmet>

      <section className="services-hero">

        <h1>Our PRO AI Writing Services</h1>

        <p>
          Our <strong>PRO AI writing services</strong> help you generate
          high-quality written content instantly.
        </p>

      </section>

      <button className="about-btn" onClick={goToHome} style={{marginLeft: "41.5%"}}>
        Generate Paragraph
      </button>

      <section className="services-grid">

        <div className="service-card">
          <h3>AI Paragraph Generator</h3>
          <p>
            Instantly generate well-structured paragraphs on any topic
            using our powerful <strong>AI paragraph generator</strong>.
          </p>
        </div>

        <div className="service-card">
          <h3>Essay Writing Assistant</h3>
          <p>
            Our <strong>AI essay writing assistant</strong> helps students
            generate detailed essay paragraphs.
          </p>
        </div>

        <div className="service-card">
          <h3>Blog Content Generator</h3>
          <p>
            Create engaging blog ideas using our
            <strong>AI blog content generator</strong>.
          </p>
        </div>

        <div className="service-card">
          <h3>Article Introduction Generator</h3>
          <p>
            Generate strong introductions using our
            <strong>AI article generator</strong>.
          </p>
        </div>

        <div className="service-card">
          <h3>Topic Idea Generator</h3>
          <p>
            Get meaningful writing ideas with our
            <strong>AI content generator</strong>.
          </p>
        </div>

        <div className="service-card">
          <h3>Creative Writing Support</h3>
          <p>
            Get inspiration using advanced
            <strong>AI writing tools</strong>.
          </p>
        </div>

        <div className="service-card">
          <h3>SEO Content Generator</h3>
          <p>
            Create SEO-optimized paragraphs that help improve your website ranking.
          </p>
        </div>

        <div className="service-card">
          <h3>Social Media Content</h3>
          <p>
            Generate engaging captions and posts for platforms like Instagram and Facebook.
          </p>
        </div>

        <div className="service-card">
          <h3>Email Writing Assistant</h3>
          <p>
            Write professional emails quickly using AI-powered suggestions.
          </p>
        </div>

        <div className="service-card">
          <h3>Product Description Generator</h3>
          <p>
            Create compelling product descriptions for eCommerce and marketing.
          </p>
        </div>

        <div className="service-card">
          <h3>Story Generator</h3>
          <p>
            Generate creative stories and ideas for storytelling and content creation.
          </p>
        </div>

        <div className="service-card">
          <h3>Content Rewriter Tool</h3>
          <p>
            Rewrite and improve your existing content to make it more engaging and readable.
          </p>
        </div>

      </section>

      <section className="services-use">

        <h2>Who Can Use Our PRO AI Writing Tools?</h2>

        <div className="use-grid">

          <div className="use-card">
            <h4>Students</h4>
            <p>Generate paragraphs for assignments and essays.</p>
          </div>

          <div className="use-card">
            <h4>Bloggers</h4>
            <p>Create blog ideas and content quickly.</p>
          </div>

          <div className="use-card">
            <h4>Content Writers</h4>
            <p>Speed up content creation using AI tools.</p>
          </div>

          <div className="use-card">
            <h4>Researchers</h4>
            <p>Generate summaries and article introductions.</p>
          </div>

        </div>

      </section>

    </div>
  );
}

export default Services;